import {
  formatBannerUrl,
  formatCardAvatarUrl,
  formatCardPosterUrl,
  toLabel,
} from '@/helpers'
import type { TvShow } from '@setplex/tria-api'
import { PARAM, PATH } from '~/shared/constants/path'
import { FormattedTvShow } from './index.h'

export function formatTvShow({ tvshow }: { tvshow: TvShow }): FormattedTvShow {
  const poster = formatCardPosterUrl(tvshow.poster || '')
  const banner = formatBannerUrl(tvshow.banner || '')
  const labels = tvshow.languages?.map((item) =>
    toLabel(item, `${PATH.TVSHOWS}?${PARAM.LANGUAGE}=`)
  )
  const item = {
    ...tvshow,
    poster,
    banner,
    labels,
  }
  if (tvshow.creator)
    item.creator = {
      ...tvshow.creator,
      avatar: formatCardAvatarUrl(tvshow.creator.avatar || ''),
    }
  return item
}
